export default __webpack_public_path__ + "static/media/BE03.970dbbf3.mp3";